export default __webpack_public_path__ + "static/media/bg-section.655d08c8.jpg";